import AsideLayout from '../baseLayouts/AsideLayout';

export { CUSTOMERROUTE } from '@/hooks/navigation/useSideMenuTree';

export const withCustomerLayout = (Component: React.ComponentType) => {
  const WrappedComponent = (props: any) => (
    <AsideLayout>
      <Component {...props} />
    </AsideLayout>
  );
  return WrappedComponent;
};
